import { Col, Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Container from "shared/components/Container";
import Form from "shared/components/Form";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers";
import validation from "./validation";
import { useLocation } from "react-router-dom";
import Select from "shared/components/Select";
import { ACTIONS_TYPES } from "utils/constants";
import graphql from "utils/api/graphql";
import { get } from "lodash";

const Configuration = ({
  isValid,
  handleSubmit,
  setFieldValue,
  values,
  FORM,
  ...formProps
}) => {
  const Widgets = {
    [ACTIONS_TYPES.MIRROR]: () => {
      return (
        <div>
          <div className="field--item">
            <Select
              type="async"
              node={[
                graphql.queries.TOKENS,
                {
                  variables: { where: {} },
                },
                "tokens.data",
              ]}
              placeholder={FORM.GENERAL_INFO.FIELDS.VALUE}
              {...bindInputProps({
                name: "fiat",
                values,
                ...formProps,
              })}
              format={(token) => token.type}
            />
          </div>
          <div className="field--item">
            <Select
              type="async"
              node={[
                graphql.queries.TOKENS,
                {
                  variables: { where: {} },
                },
                "tokens.data",
              ]}
              placeholder={FORM.GENERAL_INFO.FIELDS.VALUE}
              {...bindInputProps({
                name: "crypto",
                values,
                ...formProps,
              })}
              format={(token) => token.type}
            />
          </div>
        </div>
      );
    },
    [undefined]: () => null,
  };

  return get(Widgets, values.action, Widgets[undefined])();
};

const Create = ({ onSubmit, cancel }) => {
  const { state } = useLocation();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.RULE);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = CREATE.FORM;
  return (
    <Container>
      <Formik
        initialValues={{
          organization: { id: state.organization.id },
        }}
        onSubmit={onSubmit}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
        )}
      >
        {({ isValid, handleSubmit, setFieldValue, values, ...formProps }) => [
          <Header
            key={"header"}
            title={CREATE.HEADER.TITLE}
            subtitle={CREATE.HEADER.ACTION}
            actions={[
              {
                text: CREATE.HEADER.DISCARD,
                onClick: cancel,
                variant: "outlined",
              },
              {
                text: CREATE.HEADER.SAVE,
                onClick: handleSubmit,
              },
            ]}
          />,
          <Row gutter={[32]} key="form">
            <Col
              xs={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              md={{ span: 20, offset: 2, order: 1 }}
              lg={{ span: 14, offset: 5, order: 2 }}
            >
              <div className="inputs--container">
                <div className="inputs--container__header">
                  <span>{FORM.GENERAL_INFO.TITLE}</span>
                </div>
                <Form type={"vertical"}>
                  <div className="field--item">
                    <Input
                      placeholder={FORM.GENERAL_INFO.FIELDS.NAME}
                      {...bindInputProps({
                        name: "name",
                        values,
                        ...formProps,
                      })}
                    />
                  </div>
                  <div className="field--item">
                    <Select
                      placeholder={FORM.GENERAL_INFO.FIELDS.ACTION}
                      items={Object.values(ACTIONS_TYPES).map((type) => ({
                        label: type,
                        value: type,
                      }))}
                      {...bindInputProps({
                        name: "action",
                        values,
                        ...formProps,
                      })}
                    />
                  </div>
                  <Configuration
                    {...{
                      isValid,
                      handleSubmit,
                      setFieldValue,
                      values,
                      FORM,
                      ...formProps,
                    }}
                  />
                  <div className="field--item">
                    <Input
                      placeholder={FORM.GENERAL_INFO.FIELDS.ORGANIZATION}
                      disabled
                      value={state.organization.name}
                    />
                  </div>
                </Form>
              </div>
            </Col>
          </Row>,
        ]}
      </Formik>
    </Container>
  );
};

export default Create;
